import React, { useContext, useEffect, useState } from 'react'
import "./shop.css"
import Navbar from '../Navbar/Navbar'
import Footer from '../footer/Footer'
import { BiSearch } from "react-icons/bi";

import latest1 from "../../images/latest1.webp"
import latest2 from "../../images/latest2.webp"
import latest3 from "../../images/latest3.webp"
import latest4 from "../../images/latest4.webp"
import latest5 from "../../images/latest5.webp"
import latest6 from "../../images/latest6.webp"
import latest7 from "../../images/latest7.webp"
import latest8 from "../../images/latest8.webp"
import { Shopcontext } from '../../context/Shopcontext';
import Mainproduct from '../Mainproduct';

function Shop() {


    const { products } = useContext(Shopcontext)
    const [data, setData] = useState([])
    const [category, setCategory] = useState([])
    const [sortPrice, setSortprice] = useState("relavent")
    const [search, setSearch] = useState("")

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setData(products)
        console.log(products)

    }, [])

    useEffect(() => {
        applyFiler()
        // console.log(category)
        console.log("search", search)
    }, [category, search])

    useEffect(() => {
        sortData()
        // console.log(category)
    }, [sortPrice])



    const getcategory = (e) => {
        if (category.includes(e.target.value)) {
            setCategory(prev => prev.filter((ele) => ele !== e.target.value))
        }
        else {
            setCategory(prev => [...prev, e.target.value])
        }
        // console.log("value",e.target.value)
    }

    const applyFiler = () => {
        let productCopy = products.slice()

        if (search) {
            productCopy = productCopy.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()))
        }

        if (category.length > 0) {
            productCopy = productCopy.filter((item) => category.includes(item.category))
        }
        setData(productCopy)
    }

    const sortData = (e) => {

        let sortProductCopy = data.slice()

        switch (sortPrice) {
            case "low":
                setData(sortProductCopy.sort((a, b) => a.price - b.price))
                break;
            case "high":
                setData(sortProductCopy.sort((a, b) => b.price - a.price))
                break;
            default:
                applyFiler()
                break;
        }



    }



    return (
        <>
            <Navbar />

            <div className='shopmain'>
                <div className='shopleft'>
                    <h3>FILTERS</h3>
                    <div className='shopcatdiv'>
                        <p className='shopcatheading'>CATEGORIES</p>
                        <div className='shopcatinnerdiv'>
                            <label>
                                <input onChange={getcategory} className='shopinput' type='checkbox' value={'Wedding Cards'} />Wedding Cards
                            </label>
                            <label>
                                <input onChange={getcategory} className='shopinput' type='checkbox' value={'Engagement'} />Engagement
                            </label>
                            <label>
                                <input onChange={getcategory} className='shopinput' type='checkbox' value={'Haldi ceremoney'} />Haldi ceremoney
                            </label>
                            <label>
                                <input onChange={getcategory} className='shopinput' type='checkbox' value={'Mehendi'} />Mehendi
                            </label>
                            <label>
                                <input onChange={getcategory} className='shopinput' type='checkbox' value={'Birthday'} />Birthday
                            </label>
                            <label>
                                <input onChange={getcategory} className='shopinput' type='checkbox' value={'Baby shower'} />Baby shower
                            </label>
                            <label>
                                <input onChange={getcategory} className='shopinput' type='checkbox' value={'Wedding Anniversary'} />Wedding Anniversary
                            </label>
                        </div>
                    </div>
                </div>
                <div className='shopright'>
                    <div className='shoprightinner'>
                        <div className='shopsearchboxdiv'>
                            <div class="input-group mySearch">
                                <input
                                    type="text"
                                    value={search}
                                    class="form-control mySearch2"
                                    placeholder="Search"
                                    aria-label="Recipien"
                                    aria-describedby="basic-addon2"
                                    style={{ textTransform: "capitalize" }}
                                    onChange={(e) => { setSearch(e.target.value) }}
                                />
                                <span class="input-group-text" id="basic-addon2">
                                    <BiSearch />
                                </span>
                            </div>
                        </div>

                        <select onChange={(e) => { setSortprice(e.target.value) }} class="shopselectdiv" aria-label="Default select example">
                            <option value={'relavent'} selected>Sort by: Relavent</option>
                            <option value={'low'}>Sort by: Low to High</option>
                            <option value={'high'}>Sort by: High to Low</option>
                        </select>
                    </div>



                    <div className='shopshowproduct'>
                        {data.map((item, index) => {
                            // console.log(item)
                            return (
                                <Mainproduct key={index} id={item._id} image={item.image} name={item.name} price={item.price} />
                            )
                        })}
                    </div>
                </div>

            </div>

            <Footer />

        </>
    )
}

export default Shop
